import { render, staticRenderFns } from "./UnsentHospedajesReportsList.vue?vue&type=template&id=71c69f36&"
import script from "./UnsentHospedajesReportsList.vue?vue&type=script&lang=js&"
export * from "./UnsentHospedajesReportsList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports